import { cloneDeep } from "lodash";

const arrayMove = (arr, from, to) => {
  const clonedArr = cloneDeep(arr);
  clonedArr.splice(to, 0, clonedArr.splice(from, 1)[0]);
  return clonedArr;
};

export default arrayMove;
